'use client'

import { AboutSkeleton } from './about-skeleton'

type Props = {
  privacy_policy: string | ''
}

export function PrivacyPolicy({ privacy_policy }: Props) {
  return (
    <div className='relative mt-6 mb-4 flex justify-between py-5 text-lg'>
      {privacy_policy ? (
        <div dangerouslySetInnerHTML={{ __html: privacy_policy }} />
      ) : (
        <AboutSkeleton />
      )}
    </div>
  )
}
